import { render, staticRenderFns } from "./Samples.vue?vue&type=template&id=a24762a4&scoped=true&"
var script = {}
import style0 from "./Samples.vue?vue&type=style&index=0&id=a24762a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24762a4",
  null
  
)

export default component.exports